import { 
  getDisburseDataByLoanId as getDisburseDataByLoanIdCallback, 
  getInterestEnabledByDoctorId as getInterestEnabledByDoctorIdCallback 
} from '../api/loan-action-creator';

/**
 * Promise-based wrapper for getDisburseDataByLoanId
 * @param {string} loanId - The loan ID
 * @returns {Promise<{success: boolean, data?: any, message?: string}>}
 */
export const getDisburseDataByLoanId = (loanId) => {
  return new Promise((resolve, reject) => {
    getDisburseDataByLoanIdCallback(
      loanId,
      (result) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

/**
 * Promise-based wrapper for getInterestEnabledByDoctorId
 * @param {string} doctorId - The doctor ID
 * @returns {Promise<{success: boolean, data?: boolean, message?: string}>}
 */
export const getInterestEnabledByDoctorId = (doctorId) => {
  return new Promise((resolve, reject) => {
    getInterestEnabledByDoctorIdCallback(
      doctorId,
      (result) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

